// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"5c497860","948":"5c497860"}[chunkId] + ".chunk.css";
};